/**
 * Helper function to generate a UUID v4 string
 */
export const uuidv4 = (): string => {
  try {
    // UUID v4 using crypto RNG
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore typing crypto hacks in TS is almost impossible
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (char) => {
      const random = window.crypto.getRandomValues(new Uint8Array(1))[0]
      const value = char ^ (random & (15 >> (char / 4)))
      return value.toString(16)
    })
  } catch (error) {
    // Fallback to simple version using Math.random() as RNG
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
      const random = (Math.random() * 16) | 0
      const value = char === 'x' ? random : (random & 0x3) | 0x8
      return value.toString(16)
    })
  }
}
